"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "LazyImage", {
  enumerable: true,
  get: function get() {
    return _LazyImage.LazyImage;
  }
});
exports.ResponsiveImage = exports.Image = exports.BaseResponsiveImage = exports.BaseImage = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _CleanTag = require("../CleanTag");

var _LazyImage = require("./LazyImage");

var _styledSystem = require("styled-system");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ratioPadding = (0, _styledSystem.system)({
  ratio: {
    property: "paddingBottom",
    transform: function transform(n) {
      return n * 100 + "%";
    }
  }
});
/** Props for web & iOS images */

/**
 * Image component with space, width and height properties
 */
var BaseImage = (0, _styledComponents.default)(_CleanTag.CleanTag.as("img")).withConfig({
  displayName: "Image__BaseImage",
  componentId: "sq2zgu-0"
})(["", ";", ";", ";", ""], _styledSystem.space, _styledSystem.width, _styledSystem.height, _styledSystem.borderRadius);
exports.BaseImage = BaseImage;

/**
 * An Image component that responsively resizes within its environment
 */
var BaseResponsiveImage = (0, _styledComponents.default)(_CleanTag.CleanTag).withConfig({
  displayName: "Image__BaseResponsiveImage",
  componentId: "sq2zgu-1"
})(["background:url(", ");background-size:contain;background-repeat:no-repeat;background-position:center;", ";", ";", ";", ";"], function (props) {
  return props.src;
}, _styledSystem.space, _styledSystem.width, _styledSystem.maxWidth, function (props) {
  return props.ratio ? _objectSpread({
    height: 0
  }, ratioPadding(props)) : null;
});
exports.BaseResponsiveImage = BaseResponsiveImage;
BaseResponsiveImage.defaultProps = {
  width: "100%",
  ratio: 1
};
/** A web-only Image component. */

var Image = function Image(_ref) {
  var _ref$lazyLoad = _ref.lazyLoad,
      lazyLoad = _ref$lazyLoad === void 0 ? false : _ref$lazyLoad,
      _ref$preventRightClic = _ref.preventRightClick,
      preventRightClick = _ref$preventRightClic === void 0 ? false : _ref$preventRightClic,
      props = _objectWithoutProperties(_ref, ["lazyLoad", "preventRightClick"]);

  return /*#__PURE__*/_react.default.createElement(_LazyImage.LazyImage, _extends({
    preload: !lazyLoad,
    imageComponent: BaseImage
  }, props, {
    onContextMenu: function onContextMenu(e) {
      return preventRightClick && e.preventDefault();
    }
  }));
};

exports.Image = Image;
Image.displayName = "Image";

/**
 * A web-only ResponsiveImage component.
 * @deprecated See the recipe for creating a responsive image at https://palette.artsy.net/elements/images/image/
 */
var ResponsiveImage = function ResponsiveImage(_ref2) {
  var _ref2$lazyLoad = _ref2.lazyLoad,
      lazyLoad = _ref2$lazyLoad === void 0 ? false : _ref2$lazyLoad,
      props = _objectWithoutProperties(_ref2, ["lazyLoad"]);

  return /*#__PURE__*/_react.default.createElement(_LazyImage.LazyImage, _extends({
    preload: !lazyLoad,
    imageComponent: BaseResponsiveImage
  }, props));
};

exports.ResponsiveImage = ResponsiveImage;
ResponsiveImage.displayName = "ResponsiveImage";
//# sourceMappingURL=Image.js.map